import { render, staticRenderFns } from "./ReceiverSettings.vue?vue&type=template&id=5621ed4a&"
import script from "./ReceiverSettings.vue?vue&type=script&lang=js&"
export * from "./ReceiverSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports